module.exports = __webpack_public_path__ + "img/2keinstellungen.2faf7471.png";